import i18n from 'i18n-js';

type InactiveToggleTextParams = {
  showOnlyActiveVersions: boolean;
  inactiveVersionsCount?: number;
};

// Toggle label: "Show Inactive Versions (N)" while they are hidden (N appended if any), else "Hide Inactive Versions".
export const buildInactiveToggleText = ({ showOnlyActiveVersions, inactiveVersionsCount = 0 }: InactiveToggleTextParams): string => {
  if (!showOnlyActiveVersions) {
    return i18n.t('Hide Inactive Versions');
  }

  const countSuffix = inactiveVersionsCount > 0 ? ` (${inactiveVersionsCount})` : '';
  return `${i18n.t('Show Inactive Versions')}${countSuffix}`;
};
